<template>
  <v-row>
    <v-col cols="12" sm="12" md="12">
      <question-text
        v-model="form.question"
        :disabled="isEditable"
        :requiredMessage="questionReq"
        :id="`question-${form.id}`"
      ></question-text>
    </v-col>
    <v-col cols="12" sm="12" md="12" v-if="form.isSubtitle">
      <question-text
        class="subtitle-1"
        :label="subtitleLabel"
        v-model="form.subtitle"
        :disabled="isEditable"
        :isSubtitle="form.isSubtitle"
        :requiredMessage="subtitleReq"
        :id="`question-subtitle-${form.id}`"
      ></question-text>
    </v-col>

    <question-settings v-model="form" v-if="!isEditable"></question-settings>
  </v-row>
</template>

<script>
import MultipleSwitch from "./MultipleSwitch.vue";
import QuestionText from "./QuestionText.vue";
import QuestionSettings from "./QuestionSettings.vue";
import { mapGetters, mapState } from "vuex";
export default {
  components: { MultipleSwitch, QuestionText, QuestionSettings },
  name: "TextType",
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    responseQuestion: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      mandatoryLabel: this.$t("poll.lblMandatoryResponse"),
      question: this.value,
    };
  },
  computed: {
    ...mapState({
      surveyDetails: (state) => state.poll.surveyDetails,
    }),
    ...mapGetters({
      isSurveyExpired: "poll/isSurveyExpired",
    }),
    form: {
      get() {
        return this.question;
      },
      set(value) {
        this.question = value;
        this.$emit("input", value);
      },
    },
    questionNumber() {
      return `${this.form.number}. `;
    },
    subtitleLabel() {
      return this.$t("poll.lblSubtitle");
    },
    questionReq() {
      return this.$t("msgQuestionRequired");
    },
    subtitleReq() {
      return this.$t("msgSubtitleRequired");
    },
    isEditable() {
      if (this.isSurveyExpired) {
        return true;
      }
      return this.responseQuestion.some(
        (item) => item.questionId === this.question.id
      );
    },
  },
};
</script>

<style scoped>
.answerTextArea {
  border-radius: 0px !important;
}
</style>